import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isObject } from 'lodash';

@Pipe({
  name: 'translate2',
  pure: true
})
@Injectable()
export class Translate2Pipe implements PipeTransform {

  constructor(
    private translateProvider: TranslateService,
  ) { }

  transform(value: any): any {
    if (isObject(value)) {
      if (this.translateProvider.getDefaultLang()) {
        if (value[this.translateProvider.getDefaultLang()]) {
          return value[this.translateProvider.getDefaultLang()]
        } else {
          return value['en'] ? value['en'] : value['es'];
        }
      }
    } else {
      return this.translateProvider.get(value).toPromise();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/translate2.ts